import { Flex, Text } from '@chakra-ui/react';
import { useCOCContextData } from 'src/contexts/COCDataProvider';
import COCRecommendationBadge from './COCRecommendationBadge';
import Divider from '../../components/Divider';
export const cocAllowedStates = [
  'assignment',
  'initialAssessment',
  'peerReviewPending',
  'peerReviewInvitation',
  'peerReviewFinished',
  'revisionAssessment',
  'revisionPeerReviewInvitation',
  'revisionPeerReviewPending',
  'revisionPeerReviewFinished'
];

const RecommendationAction = () => {
  const { recommedationSummary } = useCOCContextData();
  const recommendationWorkflowData =
    recommedationSummary?.recommendationWorkflowData;

  return (
    <>
      <Flex alignItems="center" gap={2} marginTop={2} marginBottom={1}>
        <Text whiteSpace="nowrap" textStyle="textContext">
          Recommendation
        </Text>
        {Divider}

        <COCRecommendationBadge
          recommendation={
            recommendationWorkflowData?.currentState
              ? recommendationWorkflowData.currentState
              : ''
          }
          role={
            recommendationWorkflowData?.awaitingRole
              ? recommendationWorkflowData.awaitingRole
              : ''
          }
        ></COCRecommendationBadge>
      </Flex>
    </>
  );
};

export default RecommendationAction;
